import api from "./api";

const route = "/checkout";

const CheckoutService = {
  attempt: (class_package_id, discountCode, payment_method, cart, metadata) =>
    api.post(`${route}/attempt`, {
      class_package_id,
      discountCode,
      payment_method,
      cart_id: cart && cart !== null ? cart.cart_id : null,
      metadata,
    }),
  postCheckout: (class_package_id, discountCode, payment_source_id, cart, metadata) =>
    api.post(`${route}/attempt`, {
      class_package_id, 
      discountCode,
      payment_source_id ,
      cart_id: cart && cart !== null ? cart.cart_id : null,
      metadata
    }),
  postPayPal: (class_package_id, discountCode, cart, metadata) =>
    api.post(`${route}/paypal`, {
      class_package_id,
      discountCode,
      cart_id: cart && cart !== null ? cart.cart_id : null,
      metadata
    }),
  capturePayPal: (data) => api.post(`${route}/capture`, { ...data }),
};

export default CheckoutService;
